import React, { Component } from 'react';
import { Link } from '@reach/router';
import styled from 'styled-components';

import Icon from 'js/components/common/Icon';
import { lightGrey2Color } from 'js/config/style';

const Button = styled(Link)`
  grid-area: ${({ area }) => area};
  width: 2rem;
  text-align: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ disabled }) => (disabled ? lightGrey2Color.brighten(0.5) : lightGrey2Color)};

  &:hover {
    color: ${({ disabled }) => (disabled ? lightGrey2Color.brighten(0.5) : 'black')};
  }
`;

export default class PageButton extends Component {
  onClick = event => {
    if (this.props.disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  render() {
    const { name, page, ...rest } = this.props;
    return (
      <Button {...rest} onClick={this.onClick} to={`${page}`}>
        <Icon name={name} />
      </Button>
    );
  }
}
